<template>
  <div>
    <div class="container-fluid" v-if="loading">
      <div class="section-body margin-top-50">
        <LoadingAnimation :show-message="true"/>
      </div>
    </div>

    <form v-show="!loading" @submit.prevent="onCaptchaExecute">
      <div class="form register-form">
        <div class="row" :class="form.errors.has('internalError') ? ' has-error' : ''">
          <div class="col-md-12 form-group margin-bottom-30">
            <span class="black-title margin-0">Register</span>
            <span class="help-block" v-if="form.errors.has('internalError')">
                <strong>Something went wrong. Please try again later.</strong>
              </span>
          </div>
        </div>

        <div class="row margin-bottom-15">
          <label for="email" class="col-md-4 control-label input-label">E-Mail Address</label>
          <div class="col-md-12 form-group">
            <input id="email" type="email" class="form-control email-placeholder" required autofocus
                   placeholder="Email address" v-model="form.email" label="Email">
            <div class="invalid-feedback-red" v-if="form.errors.has('email')">
              {{form.errors.get('email')}}
            </div>
          </div>
        </div>

        <div class="row">
          <div class="form-group col-sm-6">
            <input-label type="text" css-class="form-control" id="first_name" v-model="form.first_name"
                         placeholder="First Name" autocomplete="nope" :required="true"/>

              <div class="invalid-feedback-red" v-if="form.errors.has('first_name')">
                {{form.errors.get('first_name')}}
              </div>

          </div>

          <div class="form-group col-sm-6">
            <input-label type="text" css-class="form-control" id="last_name" v-model="form.last_name"
                         placeholder="Last Name" autocomplete="nope" required/>

              <div class="invalid-feedback-red" v-if="form.errors.has('last_name')">
                {{form.errors.get('last_name')}}
              </div>

          </div>
        </div>

        <div class="row">
          <div class="form-group col-sm-12 password-step-1">
            <password-container
                v-model="form.password"
                autocomplete="nope"
                placeholder="Enter Password"
                label="Password"
                :required="true"
                :withLabel="true"
            />

              <div class="invalid-feedback-red" v-if="form.errors.has('password')">
                {{form.errors.get('password')}}
              </div>

          </div>
        </div>

        <div class="row">
          <div class="form-group col-sm-12">
            <password-container
                v-model="form.password_confirmation"
                autocomplete="nope"
                label="Confirm password"
                placeholder="Confirm password"
                :required="true"
                :show-hint="false"
                :withLabel="true"
            />
          </div>
        </div>

        <div class="row margin-bottom-10">
          <div class="col-sm-12">
            <div class="recaptcha-wrapper">
              <vue-recaptcha
                  ref="recaptcha"
                  @verify="onCaptchaVerified"
                  @expired="onCaptchaExpired"
                  size="invisible"
                  :sitekey="recaptchaSiteKey">
              </vue-recaptcha>
              <div class="invalid-feedback-red" v-if="form.errors.has('recaptcha_token')">
                {{ form.errors.get('recaptcha_token') }}
              </div>
            </div>
          </div>
        </div>

        <div class="row form-group">
          <div class="col-md-12">
            <button type="submit" class="width-100 btn hh-btn hh-btn-green login-btn" name="Register"
                    :disabled="loading">
              Register
            </button>
          </div>
        </div>

        <div class="form-group row account-agreement">
          <div class="col-sm-12">
            <p class="text-center account-agreement">
              By registering your account, you agree to our <a href="/terms" target="_blank">Services Agreement</a> and
              the
              <a href="https://stripe.com/connect-account/legal" target="_blank" rel="noopener">Stripe Connected Account Agreement</a>.
            </p>
          </div>
        </div>

        <div class="row hh-cta-link form" v-if="canSwitchForms">
          <div class="col-md-12 no-padding text-center">
            <p class="" @click="switchForms">
              Already have an account? <a class="cta-link ">Login here</a>
            </p>
          </div>
        </div>

      </div>
    </form>
  </div>
</template>

<script>
import {mapActions} from 'vuex'

import Form from '../../plugins/hh-form.js'
import LoadingAnimation from '../../components/LoadingAnimation'
import PasswordContainer from '../../components/form/elements/PasswordContainer'
import InputLabel from '../../components/form/elements/InputLabel'
import VueRecaptcha from 'vue-recaptcha'
import constants from "../../config.js"

export default {
  name: "RegisterModal",
  components: {
    LoadingAnimation,
    PasswordContainer,
    InputLabel,
    VueRecaptcha,
  },

  props: {
    canSwitchForms: {
      type: Boolean,
      default: true
    },
  },

  data() {
    return {
      loading: false,
      recaptchaSiteKey: null,
      form: new Form({
        email: null,
        first_name: null,
        last_name: null,
        password: null,
        password_confirmation: null,
        recaptcha_token: null,
        role: 'donor',
      }, this.$api),
    }
  },

  beforeMount() {
    this.recaptchaSiteKey = constants.RECAPTCHA_INVISIBLE_SITE_KEY
  },

  mounted() {},

  methods: {
    ...mapActions('auth', ['register']),

    async submit() {
      this.$refs.recaptcha.execute()
      this.loading = true

      await this.register(this.form)

      if (this.form.errors.any()) {
        this.onCaptchaExpired()
        this.loading = false
        return false
      }

      this.$emit('complete')
      this.loading = false
    },

    switchForms() {
      this.$emit('switchForms')
    },

    onCaptchaVerified: async function (recaptchaToken) {
      this.form.recaptcha_token = recaptchaToken
      await this.submit()
    },
    onCaptchaExpired: function () {
      this.$refs.recaptcha.reset()
    },
    onCaptchaExecute() {
      this.$refs.recaptcha.execute()
    },

  }
}
</script>

<style lang="scss" scoped>

</style>